module.exports = __webpack_public_path__ + "static/media/javaLogo.735218c7.png";